// import SectionJobCategories from "../../sections/about/section-job-categories";
// import SectionHowItWorks from "../../sections/about/section-how-it-works";
import SectionParagraph from "../../sections/about/section-paragraph"
import SectionUploadCV from "../../sections/about/section-upload-cv";
import SectionTopCompanies from "../../sections/about/section-top-companies";
import { useEffect } from "react";
import { loadScript } from "../../../../../globals/constants";
import { Helmet } from 'react-helmet-async';

function AboutUsPage() {

    useEffect(() => {
        loadScript("js/custom.js");
    })

    return (
        <>
            <Helmet>
                <title>About Us | Job Contact</title>
                <meta name="description" content="Welcome to the home page of MyApp." />
            </Helmet>
            {/* PARAGRAPH SECTION START */}
            <SectionParagraph />
            {/* PARAGRAPH SECTION END */}

            {/* JOBS CATEGORIES SECTION START */}
            {/* <SectionJobCategories /> */}
            {/* JOBS CATEGORIES SECTION END */}

            {/* HOW IT WORK SECTION START */}
            {/* <SectionHowItWorks /> */}
            {/* HOW IT WORK SECTION END */}

            {/* EXPLORE NEW LIFE START */}
            <SectionUploadCV />
            {/* EXPLORE NEW LIFE END */}

            {/* TOP COMPANIES START */}
            {/* <SectionTopCompanies /> */}
            {/* TOP COMPANIES END */}
        </>
    )
}

export default AboutUsPage;